<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-icon v-if="data.item.pacientePresencial" icon="check-circle-fill" variant="danger" font-scale="1.5"></b-icon>
    <b-icon v-else icon="x-circle-fill" variant="success" font-scale="1.5"></b-icon>
  </div>
</template>

<script>
export default {
  name: "PacientePresencialComponente",
  props: {
    data: Object,
    resource: Object
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),
  created(){
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {}
}
</script>
